import React, { ReactNode } from 'react';

import * as PopOver from '@radix-ui/react-popover';

interface PopOverProps extends PopOver.PopoverProps {
  readonly trigger: ReactNode;
  readonly children: ReactNode;
  readonly unwrap?: boolean;
  readonly className?: string;
}

function Popover({ unwrap, trigger, children, className, defaultOpen, open, onOpenChange, modal, ...props }: PopOverProps) {
  return (
    <PopOver.Root defaultOpen={defaultOpen} onOpenChange={onOpenChange} modal={modal} open={open}>
      {/* We support ...props here instead of the root to enable the Button.Group */}
      <PopOver.Trigger asChild className={className} {...props}>
        {trigger}
      </PopOver.Trigger>
      <PopOver.Portal>{unwrap ? children : <PopOver.Content sideOffset={5}>{children}</PopOver.Content>}</PopOver.Portal>
    </PopOver.Root>
  );
}

Popover.Close = PopOver.Close;
Popover.Content = PopOver.Content;

export { Popover };
